import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {IModelDictionaryDatum} from '../../model/dictionaryDatum';
import {IBaseDictionaryState, IChangeIsInitialized, IChangeIsLoading, ISetError} from './baseSlice';

export interface ICountryState extends IBaseDictionaryState {
    countries: IModelDictionaryDatum[] | null;
}

export interface IChangeCountry {
    countries: IModelDictionaryDatum[] | null;
}

const initialState: ICountryState = {
    countries: null,
    isLoading: false,
    isInitialized: false,
    error: null,
};

const countrySlice = createSlice({
    name: 'country',
    initialState: initialState,
    reducers: {
        changeCountry: {
            reducer: (state: ICountryState, action: PayloadAction<IChangeCountry>) => {
                return {
                    ...state,
                    countries: action.payload.countries,
                };
            },
            prepare(countries: IModelDictionaryDatum[] | null) {
                return {
                    payload: {countries: countries},
                };
            },
        },
        changeIsCountryLoading: {
            reducer: (state: ICountryState, action: PayloadAction<IChangeIsLoading>) => {
                return {
                    ...state,
                    isLoading: action.payload.isLoading,
                };
            },
            prepare(isLoading: boolean) {
                return {
                    payload: {isLoading: isLoading},
                };
            },
        },
        changeIsCountryInitialized: {
            reducer: (state: ICountryState, action: PayloadAction<IChangeIsInitialized>) => {
                return {
                    ...state,
                    isInitialized: action.payload.isInitialized,
                };
            },
            prepare(isInitialized: boolean) {
                return {
                    payload: {isInitialized: isInitialized},
                };
            },
        },
        setCountryError: {
            reducer: (state: ICountryState, action: PayloadAction<ISetError>) => {
                return {
                    ...state,
                    error: action.payload.error,
                };
            },
            prepare(error: string | null) {
                return {
                    payload: {error: error},
                };
            },
        },
        fetchCountries: (state: ICountryState) => {
            return {
                ...state,
                isLoading: true,
            };
        },
        fetchAllDictionaryData: (state: ICountryState) => {
            return {
                ...state,
            };
        },
    },
});

export const {changeCountry, changeIsCountryLoading, changeIsCountryInitialized, setCountryError, fetchCountries, fetchAllDictionaryData} =
    countrySlice.actions;

export default countrySlice.reducer;
